<div
  class="modal fade modal-text-color"
  id="{{modalId}}"
  #modalDialog
  tabindex="-1"
  aria-modal="true"
  role="dialog"
  [attr.aria-labelledby]="'dialog-headline-'+name"
  [attr.aria-describedby]="body !== null ? 'dialog-body-'+name : null"
>
  <div
    class="modal-dialog modal-dialog-centered ba-prompt"
    [ngClass]="{'ba-prompt': isSmallVariant}"
  >
    <div class="modal-content">
      <div class="modal-header">
        @if (hasCrossButton) {
          <button
            id="btn-dialog-dismiss-{{name}}"
            type="button"
            class="ba-modal-close"
            data-bs-dismiss="modal"
            (click)="onCloseClicked()"
          ></button>
        }
        <h1
          id="dialog-headline-{{name}}"
          class="modal-title"
          [ngClass]="showHeadlineIcon()"
        >
          {{ title }}
        </h1>
      </div>
      <div class="modal-body">
        @if (body) {
          <div id="dialog-body-{{name}}" [innerHTML]="body"></div>
        }
      </div>
      <div class="modal-footer">
        @if (cancelButtonText) {
          <button
            type="button"
            id="btn-dialog-cancel-{{name}}"
            class="ba-btn"
            data-bs-dismiss='modal'
            (click)="onCancelClicked()"
          >{{ cancelButtonText }}</button>
        }

        @if (hasConfirmButton) {
          <button
            #confirmButton
            type="button"
            id="btn-dialog-confirm-{{name}}"
            class="ba-btn ba-btn-primary"
            data-bs-dismiss='modal'
            (click)="onConfirmClicked()"
          >{{ confirmButtonText }}</button>
        }
      </div>
    </div> <!-- /.modal-content -->
  </div> <!-- /.modal-dialog -->
</div> <!-- /.modal -->
